// S :::: 이미지 불러오기 :::: S
import HomeSlide01 from "../assets/images/home/homeMainSlide01.webp";
import HomeSlide02 from "../assets/images/home/homeMainSlide02.webp";
import HomeSlide03 from "../assets/images/home/homeMainSlide03.webp";
import HomeSlide04 from "../assets/images/home/homeMainSlide04.webp";

import HomeContents01 from "../assets/images/home/HomeContents01.png";
import HomeContents02 from "../assets/images/home/HomeContents02.png";
import HomeContents03 from "../assets/images/home/HomeContents03.png";

// E :::: 이미지 불러오기 :::: E

// S ::::: 홈 메인 슬라이더 ::::: S
export const homeMainSlideLists = [
  // {
  //   key: "HomeSlide01",
  //   img: HomeSlide01,
  //   title: "INTERNATIONAL PRACTICAL",
  //   subTitle: "DANCE INSTRUCTOR ASSOCIATION",
  //   text: "국제실용댄스지도자협회",
  // },

  {
    key: "HomeSlide03",
    img: HomeSlide03,
    title: "INTERNATIONAL PRACTICAL",
    subTitle: "DANCE INSTRUCTOR ASSOCIATION",
    text: "국제실용댄스지도자협회",
  },
  {
    key: "HomeSlide02",
    img: HomeSlide02,
    title: "INTERNATIONAL PRACTICAL",
    subTitle: "DANCE INSTRUCTOR ASSOCIATION",
    text: "국제실용댄스지도자협회",
  },
  {
    key: "HomeSlide04",
    img: HomeSlide04,
    title: "INTERNATIONAL PRACTICAL",
    subTitle: "DANCE INSTRUCTOR ASSOCIATION",
    text: "국제실용댄스지도자협회",
  },
];
// E ::::: 홈 메인 슬라이더 ::::: E

// S ::::: 홈 협회 활동 ::::: S
export const homeContentsLists = [
  {
    img: HomeContents01,
    title: "[서울 본부 센터] IPDIA KOREA 국제실용댄스지도자협회 창단식 소식",
    text: "내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용",
    date: "YYYY-MM-DD",
  },
  {
    img: HomeContents02,
    title: "[서울 본부 센터] 2025년 1월 교육안내",
    text: "▪️입문반 • 화요일 (2개월) 오전 10 : 30 ~ 11 : 30 (셔플문T) • 금요일 (2개월) 오전 10 : 30 ~ 11 : 30 (셔플문T) ▪️초급반 화요일 (3개월) 오전 11 : 30 ~ 오후 12 : 30 (셔플문T)",
    date: "2025-01-03",
  },
  {
    img: HomeContents03,
    title: "2025년 새해 복 많이 받으세요!",
    text: "한 해동안 함께해 주셔서 진심으로 감사드립니다. 새해 복 많이 받으세요!",
    date: "2025-01-01",
  },
  {
    img: HomeContents01,
    title: "[서울 본부 센터] IPDIA KOREA 국제실용댄스지도자협회 창단식 소식",
    text: "내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용",
    date: "YYYY-MM-DD",
  },
];
// E ::::: 홈 협회 활동 ::::: E

// S ::::: 홈 공지사항 ::::: S
export const homeNoticesLists = [
  {
    title: "개인정보 처리방침",
    date: "2024-12-31",
  },
  {
    title:
      "제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 ",
    date: "2024-12-31",
  },
  {
    title:
      "내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용",
    date: "2024-12-31",
  },
  {
    title:
      "제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 제목 ",
    date: "YYYY-MM-DD",
  },
];
// E ::::: 홈 공지사항 ::::: E
